module.exports = __webpack_public_path__ + "exo-latin-700.d38b55777560c246992c.woff2";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/typeface-exo/files/exo-latin-700.woff2
// module id = ../../../../typeface-exo/files/exo-latin-700.woff2
// module chunks = styles